import { createContext } from 'react';

import { HoneycombTooltipMetadata } from '../types/honeycomb-internal.js';
import { HoneycombTileData } from '../types/honeycomb.js';

export const HoneycombTooltipMetadataContext = createContext<{
  tooltipMetadata: WeakMap<HoneycombTileData, HoneycombTooltipMetadata>;
}>({ tooltipMetadata: new WeakMap() });
